<template>
  <div>
    <!-- <validation-observer ref="simpleRules"> -->
      <b-row class="mb-5 border py-2 card-shadow">
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Blood and Blood Products Consent</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Consent"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.bbp_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.bbp_consent"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">High-risk Procedures and Treatments Consent</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Discharge"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.hrp_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.hrp_consent"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">History of present illness</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.hpi_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.hpi"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="2">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Systemic history</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.sys_history_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.sys_history"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5 border py-2 card-shadow">
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Past medical history</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.pmh_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.pmh"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Allergy</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.allergy_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.allergy"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Family history</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.fam_history_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.fam_history"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Eye-Examination</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.eye_exam_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.eye_exam"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5 border py-2 card-shadow">
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Referral/ Consultation</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="refConsult"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.ref_consult_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.ref_consult"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="2">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">IPSG 4</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="ips4"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.ips4_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.ips4"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">
                Anesthesia and Moderate and Deep Sedation Consent
              </h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.anes_consent_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.anes_consent"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Sedation Sheet</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.sedation_sheet_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.sedation_sheet"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5 border py-2 card-shadow">
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Pre-anesthesia Assessment</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.pre_anes_assessment_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.pre_anes_assessment"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Preoperative Assessment</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.preop_assessment_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.preop_assessment"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">
                Arrival and Discharge Time for Post-anesthesia Care
              </h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.arr_discharge_time_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.arr_discharge_time"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="2">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Nursing Assessment</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.nursing_assessment_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.nursing_assessment"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5 border py-2 card-shadow">
        <b-col md="2">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">IPSG 2</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.ips2_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.ips2"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="2">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Nutritional Screening</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.nutr_screen_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.nutr_screen"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="2">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Functional Screening</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.func_screen_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.func_screen"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="2">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Psychosocial Screening</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.psycho_screen_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.psycho_screen"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Early Screening For Discharge Planning.</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.early_discharge_plan_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.early_discharge_plan"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5 border py-2 card-shadow">
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Pain Assessment</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.pain_assessment_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.pain_assessment"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Patient/Family Education</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.pat_edu_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.pat_edu"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Assessment for fall upon admission</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.fall_assessment_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.fall_assessment"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Post operative fall assessment</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.postop_fall_assessment_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.postop_fall_assessment"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5 border py-2 card-shadow">
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Fall preventions & interventions</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.fall_prevention_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.fall_prevention"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Medication Order</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.med_order_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.med_order"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Nutritional Assessment</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.nutr_assessment_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.nutr_assessment"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="mb-2">
            <b-col md="12">
              <h6 class="mb-1">Social worker assessmenty</h6>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="operativeReport"
                  rules="required"
                >
                  <v-select
                    :options="review_status"
                    v-model="medical_reviews.sw_assessment_status"
                    :reduce="(val) => val.id"
                  >
                    <template v-slot:option="option">
                      {{ option.type }}
                    </template>
                    <template #selected-option="{ type }">
                      {{ type }}
                    </template>
                    <template #no-options>
                      {{ $t("noMatching") }}
                    </template>
                  </v-select>
                  <ValidationErrors :frontend-errors="errors" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <h6>Add Custom Comment</h6>
                <b-form-textarea
                  v-model="medical_reviews.sw_assessment"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-2 mt-2">
                  <b-col md="4">

                  </b-col>
                    <b-col md="3">
                      <h6 class="mb-1">Type status</h6>
                      <b-form-group>
                        <validation-provider
                        #default="{ errors }"
                        name="MedicalTypeStatus"
                        rules="required"
                      >
                        <v-select
                          :options="type_status"
                          v-model="medical_reviews.type_status"
                          :reduce="(val) => val.id"
                        >
                          <template v-slot:option="option">
                            {{ option.type }}
                          </template>
                          <template #selected-option="{ type }">
                            {{ type }}
                          </template>
                          <template #no-options>
                            {{ $t("noMatching") }}
                          </template>
                        </v-select>
                        <ValidationErrors :frontend-errors="errors" />
                  </validation-provider>
                      </b-form-group>
                    </b-col>
              </b-row>

              <div v-if="medicalReviewsData && medicalReviewsData.length">
      <ul>
        <li v-for="review in medicalReviewsData" :key="review.id">
          {{ review.someProperty }} <!-- Example of displaying a property from the medical review -->
        </li>
      </ul>
    </div>
<!-- 
      <b-row>
        <b-col md="12" class="mt-2">
          <b-form-group>
            <h6>Notes</h6>
            <b-form-textarea v-model="medical_reviews.notes"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row> -->
    <!-- </validation-observer> -->
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormDatepicker,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BCardHeader,
  BCardBody,
  BModal,
  VBModal,
  BPopover,
  BFormGroup,
  BForm,
  BTextArea,
  BFormTextarea,


} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { avatarText } from "@core/utils/filter";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { required, email } from "@validations";
import ValidationErrors from "@/views/components/common/ValidationErrors";
import DataTable from "@/views/components/table/DataTable";

export default {
  components: {
    ValidationErrors,
    BTextArea,
    DataTable,
    BFormGroup,
    BFormDatepicker,
    BCard,
    vSelect,
    BRow,
    BCol,
    BOverlay,
    BCardHeader,
    BCardBody,
    BForm,
    BFormInput,
    BFormTextarea,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    VBModal,
    BPopover,
    ValidationProvider,
    ValidationObserver,
    localize,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      review_status: [
        {
          id: 0,
          type: "Compliance",
        },
        {
          id: 1,
          type: " Non-Compliance",
        },
        {
          id: 2,
          type: " Missed",
        },
      ],

    type_status: [
        {
          id: 0,
          type: "Serious",
        },
        {
          id: 1,
          type: "Non-serious",
        }
      ],
      user_id: null,
      user_name: null,
      isFilterLoaded: false,
      // search:''
    };
  },
  props: {
    logs: {
      type: Boolean,
      default: false,
    },
    medicalReviewsData: {
      type: Object, // Change from Array to Object
      required: true,
    },
    

    statis: false,
  },
  computed: {
    medical_reviews: {
      get() {
        return this.medicalReviewsData;
      },
      set(value) {
        // Emit changes back to the parent when the child modifies medical_reviews
        this.$emit('medical_reviews_data', value);
      },
    },
  },

  mounted() {
    // this.loadFilterState();
    // this.fetchLookups();
    console.log("dataaaaa med",this.medicalReviewsData);

  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

th {
  color: blue;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
